import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { withStyles } from 'material-ui/styles';

import { FONT_FAMILY } from '../../../constants/styles';
import {
  actions as userCommunitiesActions,
  paginatedActions as paginatedUserCommunitiesActions,
} from '../../../redux/communities/userCommunities';
import { actions as removeNotificationsCounters } from '../../../redux/communities/removeNotificationsCounters';
import {
  actions as usersJoinRequests,
  paginatedActions as paginatedUsersJoinRequests,
} from '../../../redux/communities/usersJoinRequests';

import {
  sendingUserCommunitiesSelector,
  makeUserCommunitiesCounterSelector,
  makeUserCommunitiesListSelector,
} from '../../../redux/communities/selectors/selectors';

import {
  usersJoinRequestsListSelector,
  usersJoinRequestsCounterSelector,
} from '../../../redux/communities/selectors/usersJoinRequests';

import styles from '../index.styl';

const tabStyles = {
  root: {
    fontFamily: FONT_FAMILY.primary,
    textTransform: 'initial',
    paddingLeft: 0,
    fontWeight: 400,
  },
  label: {
    fontSize: 14,
    lineHeight: 1.5,
    paddingLeft: 0,
  },
};

const mapDispatchToProps = {
  communitiesList: userCommunitiesActions.send,
  loadNextRequests: paginatedUserCommunitiesActions.loadNextCommunities,
  removeNotifications: removeNotificationsCounters.send,
  usersJoinReq: usersJoinRequests.send,
  loadNextUserRequests: paginatedUsersJoinRequests.loadNextRequests,
};
const mapStateToProps = state => ({
  sendingRequests: sendingUserCommunitiesSelector(state),
  memberCommunitiesList: makeUserCommunitiesListSelector('memberCommunities')(
    state,
  ),
  moderatorCommunitiesList: makeUserCommunitiesListSelector(
    'moderatorCommunities',
  )(state),
  memberCommunitiesCounter: makeUserCommunitiesCounterSelector(
    'memberCommunitiesCount',
  )(state),
  moderatorCommunitiesCounter: makeUserCommunitiesCounterSelector(
    'moderatorCommunitiesCount',
  )(state),
  usersJoinRequestsList: usersJoinRequestsListSelector(state),
  usersJoinRequestsCounter: usersJoinRequestsCounterSelector(state),
});

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(tabStyles),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Communities/MyCommunities/enhance.js